<template>
  <VueDiagramEditor
    ref="diagram"
    :node-color="nodeColor"
    :node-pulsable="nodePulsable"
    :grid="false"
    :pan="false"
    :width="width"
    :height="height"
  >
    <div slot="node" slot-scope="{ node }">
      <div class="ts_item">
        <div class="item" @click="jumpPages(node)">
          <div class="iconBox" :style="{ backgroundColor: node.bgColor }">
            <img class="itemIcon" :src="node.img" alt />
          </div>
          <div class="item_right">
            <div class="mainTitle">{{ node.id }}</div>
          </div>
        </div>
      </div>
    </div>
  </VueDiagramEditor>
</template>

<script>
import VueDiagramEditor from "@/components/vue-diagram-editor/src/components/Diagram.vue";

export default {
  name: "simple-example",
  components: {
    VueDiagramEditor,
  },
  data: () => {
    let height = window.innerHeight - 245
    if(height < 800){
      height = 800
    }
    let width = height + 300
    if(width < 1200){
      width = 1200
    }
    return {
      width,
      height,
      nodes: {
        新建订单: {
          bgColor: "#9f9ff8",
          img: require("@/assets/img/newImgs/新建订单.svg"),
          x: 0,
          y: 0,
          url: "/WaybillManage/NewPickupInstructionAddEdit",
        },
        新建运单: {
          bgColor: "#9f9ff8",
          img: require("@/assets/img/newImgs/新建运单.svg"),
          url: "/WaybillManage/WaybillCreateRX",
          x: 0,
          y: 160,
        },
        提货派车: {
          bgColor: "#6ad988",
          img: require("@/assets/img/newImgs/提货派车.svg"),
          x: 260,
          y: 0,
          url: "/DispatchCar/shangmentihuo",
        },
        干线派车: {
          bgColor: "#02a7f0",
          img: require("@/assets/img/newImgs/干线派车.svg"),

          x: 260,
          y: 160,
          url: "/DispatchCar/ganxian",
        },
        在途跟踪: {
          bgColor: "#dc62cc",
          img: require("@/assets/img/newImgs/在途跟踪.svg"),
          x: 520,
          y: 160,
          url: "/DispatchCar/OnwayTrace/list",
        },
        到车管理: {
          bgColor: "#6ad988",
          img: require("@/assets/img/newImgs/到车管理.svg"),

          x: 520,
          y: 300,
          url: "/DispatchCar/FinishCar/finishCar",
        },
        到货通知: {
          bgColor: "#9f9ff8",
          img: require("@/assets/img/newImgs/到货通知.svg"),

          x: 770,
          y: 250,
          url: "/BusinessOrder/DeliveryNotice",
        },
        送货上门: {
          bgColor: "#6ad988",
          img: require("@/assets/img/newImgs/送货上门.svg"),

          x: 770,
          y: 350,
          url: "/DispatchCar/songhuoshangmen",
        },
        运单签收: {
          bgColor: "#dc62cc",
          img: require("@/assets/img/newImgs/运单签收.svg"),

          x: 1020,
          y: 300,
          url: "/WaybillManage/sign/sign",
        },
        送出外发: {
          bgColor: "#d7b938",
          img: require("@/assets/img/newImgs/送出外发.svg"),

          x: 520,
          y: 460,
          url: "/DispatchCar/songchuwaifa",
        },
        外发录入: {
          bgColor: "#02a7f0",
          img: require("@/assets/img/newImgs/外发录入.svg"),

          x: 520,
          y: 560,
          url: "/OutgoingManage/PendingOutboundEntry/List",
        },
        财务结算: {
          bgColor: "#dc62cc",
          img: require("@/assets/img/newImgs/财务结算.svg"),

          x: 770,
          y: 600,
          url: "/FM/receivableWriteOff",
        },
        回单管理: {
          bgColor: "#acd667",
          img: require("@/assets/img/newImgs/回单管理.svg"),

          x: 1020,
          y: 600,
          url: "/BusinessOrder/ReceiptManage",
        },
        异常登记: {
          bgColor: "#d7b938",
          img: require("@/assets/img/newImgs/异常登记.svg"),

          x: 1020,
          y: 40,
          url: "/ExceptionManage/ExceptionManage",
        },
      },
      links: {
        "新建订单-新建运单": "90,80 90,155",
        "新建订单-提货派车": "185,60 240,60",
        "新建运单-干线派车": "185,220 240,220",
        "干线派车-在途跟踪": "445,220 495,220",
        "在途跟踪-到车管理": "610,270 610,295",
        "到车管理-到货通知": "702,360 739,360 739,320 750,320",
        "到车管理-送货上门": "702,360 739,360 739,400 750,400",
        "到货通知-运单签收": "950,320 965,320 965,360 1000,360",
        "新建运单-外发录入": "185,240 205,240 205,570 480,570 480,620 495,620",
        "新建运单-送出外发": "185,240 205,240 205,570 480,570 480,525 495,525",
        "送出外发-运单签收": "700,525 725,525 725,570 995,570 995,380 1000,380",
        "外发录入-运单签收": "700,620 725,620 725,570 995,570 995,380 1000,380",
        "送货上门-运单签收": "950,400 965,400 965,360 1000,360",
        "到车管理-送出外发": "702,380 720,380 720,440 480,440 480,505 495,505",
        "运单签收-异常登记": "1110,315 1110,165",
        "运单签收-回单管理": "1110,415 1110,600",
        "回单管理-财务结算": "1015,660 975,660",
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$refs.diagram.setModel({
        nodes: this.nodes,
        links: this.links,
      });
    },
    format(node) {
      return JSON.stringify(node, null, 2);
    },
    nodeColor(node) {
      if (node.coordinates.x > 200) {
        return "#0f0";
      }
      if (node.coordinates.y > 200) {
        return "#f00";
      }

      return "#00f";
    },

    nodePulsable(node) {
      return node.coordinates.y > 200;
    },
    jumpPages(node) {
      this.$router.push({
        path: node.url,
      });
    },
  },
};
</script>
<style lang="less">
@borderColor: #ef7c1b;
@bgc_d7d7d7: #d7d7d7;
@linewidth: 80px;

// 设定7种颜色
@color1: #a3a3fc; //淡紫色
@color2: #02a7f0; //蓝色
@color3: #acd667; //
@color4: #dc62cc; //
@color5: #e87fa1; //
@color6: #d7b938; //
@color7: #6ad988; //
.diagram-panel {
  height: calc(100vh - 235px);
  .item {
    cursor: pointer;
    min-width: 140px;
    height: 60px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    // border: 1px solid @borderColor;
    border: 1px solid @bgc_d7d7d7;
    border-radius: 10px;
    color: #333;
    font-size: 14px;
    transition: All 0.3s ease-in-out;

    .iconBox {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      border-radius: 4px;
    }

    .itemIcon {
      width: 33px;
      height: 33px;
    }

    .item_right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      // font-size: 12px;
      // color: #666;

      .mainTitle {
        font-weight: bold;
        display: flex;
      }

      .label {
        margin-top: 4px;
        font-size: 10px;
      }
    }
  }
  .item:hover {
    // background-color: #427ff8;
    font-size: 16px;
    color: @borderColor;
    box-shadow: inset 0px 0px 5px @borderColor;
    z-index: 10;
    font-weight: bold;
    transform: scale(1.01);
  }
}
</style>
